export enum AssignmentFilterTypes {
  Company = 'company',
  Customer = 'customer',
  Worker = 'worker',
  TerminationReason = 'termination',
  Status = 'status',
}
